import { action, observable } from 'mobx';
import { GlossaryController } from 'cd-eft/services/eftPrjAdminApi';
import { GlossaryLinkResponseDto, GlossaryResponseDto, GlossaryRequestDto } from 'cd-eft/_codegen_/openapi-generator/eft-prjadmin';
import { getAlphabetArrayUpperCase, isValidUrl } from 'cd-eft/utils/stringUtilities';
import * as DOMPurify from 'dompurify';

interface IGlossaryData {
    data: GlossaryResponseDto[],
    enabled: boolean,
    letter: String;
}
export interface IGlossaryUrlLink {
    text: string,
    url: string,
    id: number,
    errorMessage: {
        textErrorMessage: string,
        urlErrorMessage: string
    }
}

type Dictionary<T> = {
    [key: string]: T;
};
export class GlossaryHelpPageVM {
    @observable loader: boolean = false;
    @observable glossaryData?: IGlossaryData[] = undefined;
    @observable uniqCatogeries?: any
    @observable glossaryAddEditMode: 'add' | 'edit' | 'delete' | null = null; // null is display mode
    @observable deletePopup = false;
    @observable rteGlossaryName: string = '';
    @observable rteGlossaryNameErrorMessage: string = '';
    @observable retGlossaryText: string = '';
    @observable retGlossaryTextErrorMessage: string = '';
    @observable rteDisableSaveButton: boolean = true;
    @observable rteLoading: boolean = false;
    @observable selectedGlossary: GlossaryResponseDto = {};
    @observable seletedDeleteGlossaries: number[] = []; // store selected glossaries IDs
    @observable glossaryDictionary: Dictionary<GlossaryResponseDto> = {}; // store selected glossaries with thier id as key
    @observable glossaryUrlLink: IGlossaryUrlLink[] =
        [
            {
                text: '',
                url: '',
                id: -1,
                errorMessage: {
                    textErrorMessage: '',
                    urlErrorMessage: ''
                }
            },
            {
                text: '',
                url: '',
                id: -1,
                errorMessage: {
                    textErrorMessage: '',
                    urlErrorMessage: ''
                }
            }
        ];
    constructor() {
    }
    // @observable glossaryData?: GlossaryResponseDto[];
    // @observable headerNavList: any = undefined;
    @action.bound onClickAddMoreUrl() {
        this.glossaryUrlLink = [
            ...this.glossaryUrlLink,
            {
                text: '',
                url: '',
                id: -1, // -1 means new url link
                errorMessage: {
                    textErrorMessage: '',
                    urlErrorMessage: ''
                }
            }
        ]
    }
    @action.bound onClickDeleteUrl(index) {
        this.glossaryUrlLink.splice(index, 1)
    }
    @action.bound onClickEdit(tile: string, description: string, glossaryLinkResponseDto: GlossaryLinkResponseDto[], selectedGlossary: GlossaryResponseDto) {
        this.rteDisableSaveButton = false;
        this.selectedGlossary = selectedGlossary;
        this.rteGlossaryName = tile;
        this.retGlossaryText = description;
        this.glossaryUrlLink = glossaryLinkResponseDto.map(
            (item) => {
                return {
                    url: item.glossaryLink!,
                    text: item.glossaryLinkDescription!,
                    id: item.glossaryLinkd!, // Backend Typo: glossaryLinkd means glossaryLinkId
                    errorMessage: {
                        textErrorMessage: '',
                        urlErrorMessage: ''
                    }
                }
            }
        )
        this.switchGlossaryAddEditMode('edit');
    }
    @action.bound handleScroll() {
        const element = document.querySelector('#glossary-body');
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    }
    @action.bound glossaryUrlOnChange(index, type, value) {
        if (type === 'text') {
            this.glossaryUrlLink[index].text = value
        }
        else if (type === 'url') {
            this.glossaryUrlLink[index].url = value
        }
    }
    @action.bound rteTextCallBack(content: string) {
        this.retGlossaryText = content;
    }
    @action.bound resetGlossaryRTE() {
        this.rteGlossaryName = '';
        this.retGlossaryText = '';
        this.glossaryUrlLink = [
            {
                text: '',
                url: '',
                id: -1,
                errorMessage: {
                    textErrorMessage: '',
                    urlErrorMessage: ''
                }
            },
            {
                text: '',
                url: '',
                id: -1,
                errorMessage: {
                    textErrorMessage: '',
                    urlErrorMessage: ''
                }
            }];
    }
    @action.bound switchGlossaryAddEditMode(mode) {
        this.glossaryAddEditMode = mode; // mode: 1. "add", 2. "edit", 3. null(close the component) 
    }
    @action.bound onClickAddGlossary() {
        this.resetGlossaryRTE()
        this.switchGlossaryAddEditMode('add');
    }
    @action.bound onClickToggleDeleteGlossary() {
        if (this.glossaryAddEditMode === 'delete') {
            this.switchGlossaryAddEditMode(null);
            this.seletedDeleteGlossaries = [];
        }
        else if (this.glossaryAddEditMode === 'edit') {
            this.seletedDeleteGlossaries = [this.selectedGlossary.glossaryId!]
            this.deletePopup = true;
        }
        else this.switchGlossaryAddEditMode('delete');
    }
    @action.bound onClickDeletePopup() {
        this.deletePopup = !this.deletePopup;
    }
    @action.bound onChangeGlossaryName(event) {
        const { name, value } = event.target;
        this.rteGlossaryName = value;
    }
    @action.bound onBlurValidation(e) {
        const { name } = e.target;
        
        this.rteDisableSaveButton = !this.validationForGlossary();
        this.handleErrorHighlighting(name);
    }
    // tox-tinymce
    handleChangeBorderColor(color?) {
        const editorContainer = document.querySelector('.tox-tinymce') as HTMLElement;
        if (editorContainer) {
            if (color === 'red') {
                editorContainer.style.borderColor = '#cd2026';
                editorContainer.style.borderWidth = '0.25rem';
                editorContainer.style.borderStyle = 'solid';
            }
            else {
                editorContainer.style.borderColor = '';
                editorContainer.style.borderWidth = '';
                editorContainer.style.borderStyle = '';
            }

        }
    };

    handleErrorHighlighting(name: string) {
        let parsed = '';
        if (name && name.includes('glossary-link')) { parsed = 'glossary-link' } else { parsed = name };

        switch (parsed) {
            case 'glossary-name':
                if (this.rteGlossaryName.length === 0) {
                    this.rteGlossaryNameErrorMessage = 'Glossary name must not be empty'
                }
                else {
                    this.rteGlossaryNameErrorMessage = ''
                }
                break;
            case 'glossary-link':
                this.glossaryUrlLink.forEach(e => {
                    if (e.text.length > 0 && e.url.length > 0 && !isValidUrl(e.url)) {
                        e.errorMessage.urlErrorMessage = 'Please enter a valid URL'
                    }
                    else if (e.text.length > 0 && e.url.length === 0) {
                        e.errorMessage.urlErrorMessage = 'URL input must not be empty'
                    }
                    else if (e.text.length === 0 && e.url.length > 0 && !isValidUrl(e.url)) {
                        e.errorMessage.urlErrorMessage = 'Please enter a valid URL';
                        e.errorMessage.textErrorMessage = 'Text input must not be empty'
                    }
                    else if (e.text.length === 0 && e.url.length > 0 && isValidUrl(e.url)) {
                        e.errorMessage.textErrorMessage = 'Text input must not be empty'
                    }
                    else {
                        e.errorMessage.urlErrorMessage = '';
                        e.errorMessage.textErrorMessage = ''
                    }
                })
                break;
            default:
                // Rich text editor
                const sanitizedDescription = DOMPurify.sanitize(this.retGlossaryText);
                if (sanitizedDescription.length === 0) {
                    this.retGlossaryTextErrorMessage = 'Glossary decription must not be empty';
                    this.handleChangeBorderColor('red');
                }
                else {
                    this.retGlossaryTextErrorMessage = ''
                    this.handleChangeBorderColor('');
                }
                break;

        }
    }

    validationForGlossary(): boolean {
        const sanitizedDescription = DOMPurify.sanitize(this.retGlossaryText);
        let validateGlossaryUrlLink: any = true;
        if (this.glossaryUrlLink.length > 0) {
            validateGlossaryUrlLink = this.glossaryUrlLink.reduce((acc, e) =>
                acc && ((e.text.length > 0 && e.url.length > 0 && isValidUrl(e.url)) || (e.text.length === 0 && e.url.length === 0)), true
            )
        }
        return (this.rteGlossaryName.length > 0 && sanitizedDescription.length > 0 && validateGlossaryUrlLink)
    }

    @action.bound async handleGlossarySave() {
        this.rteLoading = true;
        if (this.validationForGlossary()) {
            this.rteGlossaryNameErrorMessage = '';
            this.retGlossaryTextErrorMessage = '';
            const glossaryLinkRequestDto = this.contrsuctGlossaryLinkRequestDto();
            if (this.glossaryAddEditMode === 'edit') {
                const requestObject: GlossaryRequestDto = {
                    createdBy: this.selectedGlossary.createdBy,
                    deleted: this.selectedGlossary.deleted,
                    glossaryCategory: this.selectedGlossary.glossaryCategory,
                    glossaryDescription: DOMPurify.sanitize(this.retGlossaryText),
                    glossaryId: this.selectedGlossary.glossaryId,
                    glossaryLinkRequestDto: glossaryLinkRequestDto === undefined ? [] : glossaryLinkRequestDto,
                    glossaryTitle: this.rteGlossaryName,
                    titleChar: this.rteGlossaryName[0].toUpperCase()
                }
                try {
                    await GlossaryController.updateGlossaryUsingPUT(requestObject);
                    await this.getGlossaryData();
                    await this.getGlossaryDataByCategorySummary();
                }
                catch (error) {
                    console.error(error);
                }
            }
            else if (this.glossaryAddEditMode === 'add') {
                const requestObject: GlossaryRequestDto = {
                    createdBy: String(localStorage['username']),
                    deleted: false,
                    // glossaryCategory: undefined,
                    glossaryDescription: DOMPurify.sanitize(this.retGlossaryText),
                    // glossaryId
                    glossaryLinkRequestDto: glossaryLinkRequestDto,
                    glossaryTitle: this.rteGlossaryName,
                    titleChar: this.rteGlossaryName[0].toUpperCase()
                }
                try {
                    await GlossaryController.createGlossaryUsingPOST(requestObject);
                    await this.getGlossaryData();
                    await this.getGlossaryDataByCategorySummary();
                }
                catch (error) {
                    console.error(error);
                }
            }
        }
        this.rteLoading = false;
        this.rteDisableSaveButton = true;
        this.switchGlossaryAddEditMode(null);
    }
    @action.bound async deleteGlossaryHandler() {
        this.loader = true;
        this.deletePopup = false;
        const response = await GlossaryController.deleteGlossaryByGlossaryIdsUsingPOST(this.seletedDeleteGlossaries);
        await this.getGlossaryData();
        await this.getGlossaryDataByCategorySummary();
        this.seletedDeleteGlossaries = [];
        this.switchGlossaryAddEditMode(null);
        this.handleScroll();
        this.loader = false;
    }
    contrsuctGlossaryLinkRequestDto() {
        let glossaryLinkRequestDto;
        if (this.glossaryUrlLink.length > 0) {
            glossaryLinkRequestDto = this.glossaryUrlLink.filter((item) => item.text.length > 0 && item.url.length > 0 && isValidUrl(item.url))
                .map((item) => {
                    return {
                        deleted: false,
                        glossaryLink: item.url,
                        glossaryLinkDescription: item.text,
                        glossaryLinkId: item.id
                    }
                })
            if (glossaryLinkRequestDto.length === 0) glossaryLinkRequestDto = []
        }
        return glossaryLinkRequestDto;
    }

    @action.bound handleGlossaryCancel() {
        this.rteDisableSaveButton = true;
        this.seletedDeleteGlossaries = [];
        this.rteGlossaryNameErrorMessage = '';
        this.retGlossaryTextErrorMessage = '';
        this.switchGlossaryAddEditMode(null);
    }

    @action.bound onChangeCheckDeleteGlossary(id: number) {

        if (this.seletedDeleteGlossaries.includes(id)) {
            this.seletedDeleteGlossaries.splice(this.seletedDeleteGlossaries.indexOf(id), 1)
        }
        else {
            this.seletedDeleteGlossaries.push(id)
        }
    }
    @action.bound async getGlossaryData() {
        try {
            const response = await GlossaryController.getAllGlossaryUsingGET();
            if (response && response.data) {
                this.initHeaderNavList(response.data);
                response.data.forEach(e => { this.glossaryDictionary[e.glossaryId!] = e });
            }
        }
        catch (error) {
            console.error(error);
        }
    }
    //get glossary data based on summary
    @action.bound async getGlossaryDataByCategory(item?: any) {
        try {
            const responseByCategory = await GlossaryController.getByCategoryUsingGET(item);
            if (responseByCategory && responseByCategory.data) {
                this.initHeaderNavList(responseByCategory.data);
            }
        }
        catch (error) {
            console.error(error);
        }
    }

    //get the number of items in each summary
    @action.bound async getGlossaryDataByCategorySummary(item?: any) {
        try {
            const responseByCategorySummary = await GlossaryController.getCategorySummaryUsingGET(item);
            if (responseByCategorySummary && responseByCategorySummary.data) {
                this.uniqCatogeries = responseByCategorySummary.data
            }
        }
        catch (error) {
            console.error(error);
        }
    }

    // Set headerNavList to object with keys being capital alphabet, boolean values (all false)
    @action.bound initHeaderNavList(data?: GlossaryResponseDto[]) {
        const alhpabetArr = getAlphabetArrayUpperCase(); // add spcecial category to A-Z list
        const categoryArr = [...alhpabetArr, 'Other']
        this.glossaryData = [];
        for (let i = 0; i < 27; i++) {
            this.glossaryData.push(
                {
                    letter: categoryArr[i],
                    data: [],
                    enabled: false
                }
            )
        }
        if (data && data.length > 0) {
            for (let i = 0; i < data.length; i++) {
                const letter = data[i].glossaryTitle!.slice(0, 1).toLocaleUpperCase();// replace with letter from dto.
                const index = this.glossaryData.findIndex((entry, i) => entry.letter === letter);
                // special category
                if (index === -1) {
                    this.glossaryData[26].data.push(data[i])
                    this.glossaryData[26].enabled = true;
                }
                else {
                    this.glossaryData[index].data.push(data[i]);
                    this.glossaryData[index].enabled = true;
                }
            }
        }
    }
}